import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RecoilRoot } from "recoil";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { BrowserRouter } from "react-router-dom";
import { getConfig } from "Config/config";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
const { GoogleOAuthID } = getConfig();
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <GoogleOAuthProvider clientId={GoogleOAuthID}>
          <RecoilRoot>
            <App />
          </RecoilRoot>
        </GoogleOAuthProvider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
